import { QueryClient } from 'react-query';
import { showModalError } from './modal';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      onError: (error) => showModalError({ content: error?.message || '' }),
    },
    mutations: {
      onError: (error) => showModalError({ content: error?.message || '' }),
    },
  },
});

const queryCache = queryClient.getQueryCache();

export { queryCache };

export default queryClient;
